import { Component, Input } from '@angular/core';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { UserStepService } from 'src/app/services/user-step.service';

@Component({
  selector: 'app-weekly-report-chart-strong',
  templateUrl: './weekly-report-chart-strong.component.html',
  styleUrls: ['./weekly-report-chart-strong.component.scss']
})
export class WeeklyReportChartStrongComponent {
  @Input() weeksData:any;

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    
    labels: [
    ],
    datasets: [
      {
        data: [  ],
        label: 'Prep Strong Sessions',
        fill: true,
        tension: 0.5,
        borderColor: '#01E5BE',
        borderWidth:2,
        backgroundColor: '#01E5BE',
        pointBackgroundColor:'#01E5BE',
        pointBorderColor:'#ffffff',
      }
    ]
  };
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    plugins:{
      legend:{
        position:'bottom'
      }
    },
    scales:{
      y:{
        type: 'linear',
        display: true,
        position: 'left',
        suggestedMax: 7,
        suggestedMin: 0,
        beginAtZero:true,
        title: {
          display: true,
          text: "SESSION PER WEEK",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      },
      x:{
        display: true,
        title: {
          display: true,
          text: "WEEK NUMBER",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      }
    },
  };
  public lineChartLegend = false;


  constructor() {}

  ngOnInit(): void {
    this.setChartData();

  }

  setChartData() {
    
    this.lineChartData.datasets[0].data = [];
    this.lineChartData.labels = [];
   
    // setup chart data
    this.weeksData.slice().reverse().forEach((weekData:any, weekNo:number) => {
      //console.log(weekData[0].date);
      this.lineChartData.labels?.push(
        weekNo+1
      );
        var sessions = 0;
        weekData.forEach((day:any) =>{
          if(+day.total_reps>0){
            sessions++;
          }
        });
      this.lineChartData.datasets[0].data.push(sessions);
    });
  }


}
